import { createContext } from "react";
import { DataResponse } from "../helpFunction/helpFunction";
import { loadingType } from "../Cloude";

export interface optionsFTP {
	urlFtp: string;
	passFtp: string;
	userFtp: string;
	portFtp: string;
}
export interface ContextHomeInterface {
	setLoading: (e: boolean | loadingType) => void;
	setReload: (e: boolean) => void;
	reload: boolean;
	connect: boolean;
	setConnect: (e: boolean) => void;
	listAll: () => void;
	data: DataResponse[];
	setData: (e: DataResponse[]) => void;
	path: string;
	setPath: (e: string) => void;
	setLoadingProgress: (e: number | null) => void;
	setLongPressed: (e: boolean) => void;
	LongPressed: boolean;
	selectedFiles: string[];
	setSelectedFiles: (e: string[]) => void;
	loadingProgress: number | null;
	loading: boolean | loadingType;
	clearAndReload: () => void;
	setMenuEnabled: (e: boolean) => void;
	setFirstTach: (e: boolean) => void;
	firstTach: boolean;
}
export const ContextHome = createContext<ContextHomeInterface | null>(null);
export interface OptionsFTPInterface {
	setOptions: (e: optionsFTP) => void;
	options: optionsFTP;
	getOptions: () => void;
	saveOptions: () => void;
}
export const ContextOptionsFTP = createContext<OptionsFTPInterface | null>(null);
